<template>

  <div class="box bf-sat-blur" v-if="not_show.indexOf(family.descrizione.toLowerCase()) < 0">

    <div class="wrapper">

      <a :href="url('/family-article/'+family.codice)">
      <div class="abs">
        <img :src="url('/media/icons/svg/family/white/'+family.codice.toLowerCase()+'.svg')" alt="Icona famiglia articoli">
        <span class="desc-family ttl">{{family.descrizione}}</span>
      </div>
      </a>

    </div>

  </div>

</template>

<script>
export default{

  props: {
    family: {
      required: true
    },
    not_show: {
      required: false,
      default: ['custom']
    }
  },

  data(){
    return {

    }
  }

}
</script>

<style scoped>
.box{
  position: relative;
  z-index: 1;
}
.wrapper{
  position: relative;
  padding-bottom: 60%;
}
.box .abs{
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-weight: 300;
}
.box img{
  display: block;
  height: auto;
  max-height: 62px;
  margin-bottom: 10px;
}
.box .desc-family{
  text-align: center;
  font-size: 0.9em;
}

@media screen and (max-width: 500px) {

  .section .wrapper-data .content-data .box img{
    max-height: 50px;
  }

}

@media screen and (max-width: 3900px) {

  .section .wrapper-data .content-data .box img{
    max-height: 60px;
  }

}
</style>
